<!--
 * @Descripttion:
 * @Version: 1.0.0
 * @Author: Liu ShuaiBo
 * @Date: 2021-10-26 20:06:36
 * @LastEditors: 吴作杰 15727841808@163.com
 * @LastEditTime: 2024-03-12 15:46:12
-->
<template>
	<div class="mt-12 yx-form-wrap">
		<Search @onSearch="onSubmit" @onReset="onClear">
			<el-form :inline="true" :model="formData" label-width="96px">
				<el-form-item label="商品名称">
					<el-input v-model="formData['productName']" placeholder="请输入商品名称"></el-input>
				</el-form-item>
				<el-form-item label="商品ID">
					<el-input v-model="formData['thirdProductId']" placeholder="请输入商品ID"></el-input>
				</el-form-item>
				<el-form-item label="店铺名称">
					<shop-name-select ref="shopNameSelect" passive :key="platformId" :platformId="platformId" v-model="formData.outerShopId"></shop-name-select>
				</el-form-item>
				<el-form-item label="推广状态">
					<el-select v-model="formData['status']" clearable placeholder="请选择推广状态">
						<el-option :label="item.label" :value="item.value" v-for="(item, index) in goodsPromoteStatusArr" :key="index"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="佣金率">
					<div class="scope-input">
						<el-input v-model="formData['commissionRateStart']" placeholder="最小值" class="input_width"></el-input>
						<span class="flag">至</span>
						<el-input v-model="formData['commissionRateEnd']" placeholder="最大值" class="input_width"></el-input>
					</div>
				</el-form-item>
				<el-form-item label="直播价">
					<div class="scope-input">
						<el-input v-model="formData['livePriceStart']" placeholder="最小值" class="input_width"></el-input>
						<span class="flag">至</span>
						<el-input v-model="formData['livePriceEnd']" placeholder="最大值" class="input_width"></el-input>
					</div>
				</el-form-item>
				<el-form-item label="现售价">
					<div class="scope-input">
						<el-input v-model="formData['salePriceStart']" placeholder="最小值" class="input_width"></el-input>
						<span class="flag">至</span>
						<el-input v-model="formData['salePriceEnd']" placeholder="最大值" class="input_width"></el-input>
					</div>
				</el-form-item>
				<el-form-item label="服务费率" v-if="$auth.hasPermi('system:goods-ServiceRate')">
					<div class="scope-input">
						<el-input v-model="formData['serviceRateStart']" placeholder="最小值" class="input_width"></el-input>
						<span class="flag">至</span>
						<el-input v-model="formData['serviceRateEnd']" placeholder="最大值" class="input_width"></el-input>
					</div>
				</el-form-item>
				<el-form-item :label="zsName" prop="userId">
					<zs-partner-select
						v-model="formData.bd_user_ids"
						:collapseTags="true"
						:multiple="true"
						:customData="[{ name: '未认领', userId: 0 }]"
					></zs-partner-select>
				</el-form-item>
				<el-form-item label="授权团长">
					<commander-select :platformId="platformId" v-model="formData['authorityId']" :show-all="true"></commander-select>
				</el-form-item>
				<el-form-item label="到期时间" prop="start_time">
					<el-date-picker
						v-model="freeOrderTime"
						type="daterange"
						@change="changeTimed"
						value-format="yyyy-MM-dd"
						range-separator="至"
						start-placeholder="开始日期"
						end-placeholder="结束日期"
					>
					</el-date-picker>
				</el-form-item>
			</el-form>
			<defaultFilterTag
				@applicationSetting="applicationSetting"
				:dynamicsList="dynamicsList"
				:listType="listType"
				:platformId="platformId"
				slot="operate"
			/>
		</Search>
	</div>
</template>

<script>
import throttle from 'lodash/throttle';
import ZsPartnerSelect from '@/components/zsPartnerSelect';
import { ksMyActivityUpStateList, zsRoleType } from '@/utils/dataMap';
import { goodsPromoteStatusArr } from '@/utils/newDataMap/shopManage';
import { format, addDays } from 'date-fns';
import { isEqual } from 'lodash';
import commanderSelect from '@/components/commanderSelect/index.vue';
import { pageConfig } from '@/utils/dataMap';
import defaultFilterTag from '@/components/business/defaultFilter';
import { configList } from './searchConfig';
import shopNameSelect from '@/components/shopNameSelect/shopNameSelect.vue';
export default {
	name: 'search',
	components: {
		ZsPartnerSelect,
		commanderSelect,
		defaultFilterTag,
		shopNameSelect,
	},
	props: {
		platformId: {
			type: [String, Number],
			default: '',
		},
	},
	data() {
		return {
			formData: {
				status: '',
				authorityId: '',
				outerShopId: '',
			},
			freeOrderTime: '',
			goodsPromoteStatusArr,
			auditStatusArr: ksMyActivityUpStateList,
			listType: pageConfig.trusteeshipSearch,
		};
	},
	computed: {
		zsName() {
			return zsRoleType.name;
		},
		dynamicsList() {
			return configList;
		},
	},
	methods: {
		onClear() {
			this.formData = {
				status: '',
				authorityId: '',
				outerShopId: '',
			};
			this.freeOrderTime = '';
			this.$refs.shopNameSelect.clear();
			this.onSubmit();
		},
		changeTimed(value) {
			const [start, end] = value || [];
			this.formData.trusteeshipTimeStart = start ? Date.parse(start) / 1000 - 8 * 3600 : '';
			this.formData.trusteeshipTimeEnd = end ? Date.parse(end) / 1000 + 16 * 3600 - 1 : '';
		},
		onSubmit: throttle(function () {
			if (!isEqual(this.temFreeOrderTime, this.freeOrderTime) || this.formData.status != 1) {
				this.$emit('clearImminent');
			}
			this.$emit('onSubmit', this.formData);
		}, 1000),
		imminentSelect(toggle) {
			// 仅快手回显
			if (toggle) {
				const val = [format(new Date(), 'yyyy-MM-dd'), format(addDays(new Date(), 6), 'yyyy-MM-dd')];
				this.temFreeOrderTime = val;
				this.freeOrderTime = val;
				this.changeTimed(val);
				this.formData.status = 1;
			} else {
				this.temFreeOrderTime = null;
				this.freeOrderTime = [];
				this.formData.trusteeshipTimeStart = '';
				this.formData.trusteeshipTimeEnd = '';
				this.formData.status = '';
			}
			this.onSubmit();
		},
		applicationSetting(val) {
			this.formData = val;
			this.$emit('onSubmit', this.formData);
		},
	},
};
</script>

<style lang="less" scoped></style>
